export class BBox {
  x: number;
  y: number;
  height: number;
  width: number;

  constructor(x?: number, y?: number, width?: number, height?: number) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }
}
